import { SkuMovementMessages } from "@/messages/sku/sku-movement.messages";
import { SelectData } from "@/types/form.types";

import { Type } from "./form-data";

export const MOVEMENT_TYPE_OPTIONS = (messages: SkuMovementMessages): SelectData<string>[] => {
  const { entryOption, exitOption } = messages;

  return [
    { value: Type.ENTRY, label: entryOption },
    { value: Type.OUT, label: exitOption },
  ];
};
